module.exports = __webpack_public_path__ + "static/img/Arrafi Maulana-close.6d68f27.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/profile/closeup/Arrafi Maulana-close.jpg
// module id = PAUC
// module chunks = 1